export default {
    name: "Detail",
    data() {
        return {
            form: {
                systemFunctionIdLists: []
            },
            checkedAuth: []
        }
    },
    watch: {
        '$i18n.locale' (val) {
            this.refreshAuthInfo(this.form, val);
        }
    },
    created() {
        this.conditionData = this.$routerUtil.getParam();
        const data = this.conditionData.data;
        this.refreshAuthInfo(data, this.$i18n.locale);
        this.form = Object.assign({}, this.form, data);
        this.form.isEnableName = this.form.isEnable === 1 ? this.$t('userManage.stateEnable'): this.$t('userManage.stateDisable')
    },
    methods: {
        refreshAuthInfo(data, locale) {
            this.checkedAuth.splice(0, this.checkedAuth.length);
            data.systemFunctionIdLists.forEach(item => {
                item.disabled = true;
                if (item.children) {
                    item.children.forEach(row => {
                        if (row.isChecked) {
                            this.checkedAuth.push(row.code);
                        }
                        this.itemLabel(row, locale);
                        row.disabled = true;
                    });
                }else{
                    if(item.isChecked) {
                        this.checkedAuth.push(item.code);
                    }
                }
                this.itemLabel(item, locale);
            });
        },
        itemLabel(item, locale) {
            if(locale.indexOf('en') !== -1){
                item.label = item.tooltipText;
            }else{
                item.label = item.displayText;
            }
        },
        back() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.back();
        }
    }
}